<div
  class="pre-pack-card p-3 d-flex w-100 align-items-start"
  (click)="togglePrePack()"
>
  <epc-pre-pack-header
    [thumbnailsVisible]="thumbnailsVisible"
    [prepack]="prepack"
    [opened]="opened"
    [totalItemsInPrepactText]="totalItemsInPrepactText"
    [numberOfImagesToDisplay]="numberOfImagesToDisplay"
    [quantityLeft]="quantityLeft"
    [quantityWarningThreshold]="quantityWarningThreshold"
    [lowInvetoryWarningText]="lowInvetoryWarningText"
    (clickedMaterialImage)="clickedMaterialImage.emit($event)"
  ></epc-pre-pack-header>

  @if (inboundQuantity > 0) {
  <div class="pre-pack-row-item">
    <atx-badge class="mr-2" [icon]="['fas', 'truck']" [title]="inboundTitle">
      {{ inboundQuantity }}
    </atx-badge>
  </div>
  } @if (discountVisible) {
  <div class="pre-pack-row-item">
    <atx-discount-label
      *atxCanShowByWsp
      class="mr-2 d-flex align-items-center justify-content-center text-success"
      [discount]="discount"
    ></atx-discount-label>
  </div>
  }
  <div class="pre-pack-row-item">
    <atx-clikable-amount-input
      [formControl]="quantityControl"
      [max]="maxAvailableQuantity"
      (click)="$event.stopPropagation(); onQuantityChange()"
    ></atx-clikable-amount-input>
  </div>
</div>

<epc-pre-pack-details
  [deliveryItems]="deliveryItems"
  [prepack]="prepack"
  [discount]="discount"
  [scaleSets]="scaleSets"
  [selectedScale]="selectedScale"
  [showAddNote]="showAddNote"
  [collapseState]="collapseState"
  [titleAttributes]="titleAttributes"
  [portableGrid]="true"
  [note]="note"
  [differentMaterialDimensions]="differentMaterialDimensions"
  [productImageMissingVisualConfig]="productImageMissingVisualConfig"
  (noteChanged)="noteChanged.emit($event)"
  (clickedMaterialImage)="clickedMaterialImage.emit($event)"
></epc-pre-pack-details>
